/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./subscriptionAdjustment.module.css";
import SubscriptionAdjustmentTable from "../subscriptionAdjustment/subscriptionAdjustmentTable";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import ResendDialog from "../order/resendDialog";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Select from "@mui/material/Select";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import { IconButton } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
} from "../../../component/icons/icons";
import Button from "../../../component/button";
import { Grid } from "@mui/material";
import SubscriptionHistory from "./subscriptionHistory";
import ApprovalDialog from "./ApprovalDialog";
import Card from "@mui/material/Card";
import { withNavigation } from "../../../helper/withNavigation";
import dateFormat from "dateformat";

// Manage order page class
class SubscriptionAdjustment extends Component {
  // Declare property values that belongs to the component
  state = {
    subscriptionAdjustment: {},
    subAdjustmentId: "",
    subscriptionHistory: [],
    loading: true,
    isMailDialog: false,
    bread: [
      {
        title: this.props.t("SUBSCRIPTION_ADJUSTMENTS"),
        url: "/subscriptionadjustments",
      },
    ],
    showLoading: true,
    isApprovalForm: false,
    taskForm: {},
    adjustment: {},
  };
  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    let subAdjustmentId = this.props.router.params.subscriptionAdjustmentId;
    if (subAdjustmentId) {
      this.setState({
        subAdjustmentId,
      });
    }
    this.getSubscriptionAdjustment();
  }

  getSubscriptionAdjustment = () => {
    this.setState({
      loading: true,
      showLoading: true,
    });

    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/subscriptionAdjustments/${this.props.router.params.subscriptionAdjustmentId}`,
      {},
    )
      .then((res) => {
        let data = res.data;
        this.setState({
          subscriptionAdjustment: data,
          adjustment: data,
          subscriptionHistory: data.history,
          loading: false,
          showLoading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleApprovalForm = () => {
    this.setState({
      loading: true,
      showLoading: true,
    });

    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/subscriptionAdjustments/${this.props.router.params.subscriptionAdjustmentId}?operation=taskForms`,
      {},
    )
      .then((res) => {
        console.log("taskForm===", res.data);
        let data = res.data;
        this.setState({
          taskForm: data,
          isApprovalForm: true,
          loading: false,
          showLoading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  handleClose = () => {
    this.setState({
      isApprovalForm: false,
    });
  };

  handleApproval = (val) => {
    this.setState({
      isApprovalForm: false,
      loading: false,
    });
    const { t } = this.props;
    if (val) {
      if (val === "Approve") {
        this.props.setErrorMessage(t("ADJUSTMENT_APPROVED_SUCCESFULLY"), true);
      } else {
        //setAdjustment({});
        this.props.setErrorMessage(t("ADJUSTMENT_REJECTED_SUCCESFULLY"), true);
      }
      this.getSubscriptionAdjustment();
    }
  };

  // Render order view
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
                <div className={"bottomBreadcrumbText"}>
                  <h3 className={classes.orderHeaderInfo}>
                    {` Adjustment  #${this.state.subAdjustmentId}`}
                    <b>
                      {`  Status : ${this.state.subscriptionAdjustment.status}`}
                    </b>
                  </h3>
                </div>
              </Grid>
              <Grid
                item
                style={{ textAlign: "right" }}
                size={{
                  xs: 6,
                }}
              >
                {this.state.subscriptionAdjustment.status ==
                  "PENDING_APPROVAL" &&
                this.props.userPerms.includes("ADJUSTMENTS_APPROVER") ? (
                  /*Pratyush - Check if the user has the new Subscription Adjustment Permission*/
                  <Button onClick={this.handleApprovalForm}>
                    {this.props.t("Approve")}
                  </Button>
                ) : null}
              </Grid>
            </Grid>
          </div>
        </div>
        <div style={{ position: "relative" }}>
          {/* <Paper className="tablePaper"> */}
          <Card variant="outlined" style={{ borderRadius: "8px" }}>
            {/* Subscription Adjustment table component */}
            <SubscriptionAdjustmentTable
              subAdjustmentId={this.state.subAdjustmentId}
              subscriptionAdjustments={this.state.subscriptionAdjustment}
              openResendDialog={this.openResendDialog}
              controls={this.state.controls}
              loggedInUserType={this.props.loggedInUserType}
              showLoading={this.state.showLoading}
              navigate={this.props.router.navigate}
            />
          </Card>
          {/* </Paper> */}
          <SubscriptionHistory
            subAdjustmentId={this.state.subAdjustmentId}
            subscriptionHistory={this.state.subscriptionHistory}
            getSubscriptionHistory={this.getSubscriptionAdjustment}
            loggedInUserType={this.props.loggedInUserType}
            showLoading={this.state.showLoading}
          />
          <Loader loading={this.state.loading} />
          <ApprovalDialog
            isOpen={this.state.isApprovalForm}
            close={this.handleApproval}
            taskForm={this.state.taskForm}
            adjustment={this.state.adjustment}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    menuPaths: state.auth.menuPaths,
    userPerms: state.auth.userPerms,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(SubscriptionAdjustment)));
